<template>
    <div class="mainBox">
        <div class="boxTop">
            <h5>企业排行榜</h5>
            <div class="sortBtn" @click="handleUpOrDown">
                <span>排序</span>
                <div>
                    <img src="../../../assets/image/ic_px@2x.png" v-show="isUpSort">
                    <img src="../../../assets/image/ic_d_px@2x.png" v-show="!isUpSort">
                </div>
            </div>
        </div>
        <ul class="rankingList">
              <li v-for="(item, index) in EnterpriseRankingData" :key="index">
                <span>{{(1*index+1)+"、"}}</span>
                <p>{{item.name}}</p>
                <span >{{item.score}}分</span>
            </li>
        </ul>
        <router-link class="toMore" :to="{path: '/integrity/moreEnterprises', query: { ind: ind ,cityCode:cityCode}}">
            <span>查看更多排名</span>
            <img src="../../../assets/image/ic_lb_jt@3x.png">
        </router-link>
    </div>
</template>

<script>
    export default {
        name: 'EnterpriseRanking',
        // props: ['EnterpriseRankingData'],
        props: {
            EnterpriseRankingData: {
                type: Array,
                default: null
            },
            ind: {
                type: Number,
                default: 0
            },
            cityCode:{
                type:String
            }

        },
        data () {
            return {
                isUpSort: true,
                sortData: []
            }
        },
        mounted () {
            this.sortData = this.upData;
        },
        methods: {
            handleUpOrDown () {
                this.isUpSort = !this.isUpSort;
                this.$emit('changeEnterpriseRankingFlag')
                // if (this.isUpSort) {
                //     this.isUpSort = !this.isUpSort;
                //     this.$emit('changeEnterpriseRankingFlag')
                // } else {
                //     this.isUpSort = !this.isUpSort;
                //     this.$emit('changeEnterpriseRankingFlag')
                // }
            }
        }
    }
</script>

<style lang="less" scoped>
    .mainBox{
        width:100%;
        background-color:#fff;
        padding: 24px 16px;
    }

    .boxTop{
        margin-bottom: 16px;
    }

    .boxTop::after{
        content: "";
        display: block;
        clear: both;
    }

    .boxTop>h5{
        font-size: 14px;
        font-weight: bold;
        float: left;
    }

    .boxTop>.sortBtn{
        float: right;
    }

    .sortBtn{
        text-align: center;
        line-height: 12px;
    }

    .sortBtn::after{
        content: "";
        display: block;
        clear: both;
    }

    .sortBtn>span{
        margin-right: 3px;
        float: left;
    }

    .sortBtn>div{
        width: 14px;
        height: 12px;
        float: left;
    }

    .sortBtn>div>img{
        width: 14px;
        height: 12px;
        color: #eeeeee;
    }

    .rankingList{
        margin-bottom: 16px;
    }

    .rankingList>li{
        color: #666;
    }

    .rankingList>li::after{
        content: "";
        display: block;
        clear: both;
    }

    .rankingList>li>span:first-child{
        line-height: 28px;
        float: left;
    }

    .rankingList>li>span:last-child{
        line-height: 28px;
        float: right;
    }

    .rankingList>li>p{
        max-width: 270px;
        line-height: 28px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        float: left;
    }

    .toMore{
        width: 100%;
        margin: 0 auto;
        text-align: center;
        color: #9B9B9B;
        display: flex;
        justify-content: center;
    }

    // .toMore::after{
    //     content: "";
    //     display: block;
    //     clear: both;
    // }

    // .toMore>span{
    //     float: left;
    // }

    .toMore>img{
        width: 8px;
        height: 8px;
        margin-left: 2px;
        float: left;
        position: relative;
        top: 1.8px;
    }
</style>
